'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { getENV } from '../../../utils/env';
export const GtmLegacy = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getENV();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    NEXT_PUBLIC_LOCALE,
    NEXT_PUBLIC_GTM_CA_CONTAINER_ID,
    NEXT_PUBLIC_GTM_CA_PREVIEW,
    NEXT_PUBLIC_GTM_CA_AUTH,
    NEXT_PUBLIC_GTM_US_CONTAINER_ID,
    NEXT_PUBLIC_GTM_US_PREVIEW,
    NEXT_PUBLIC_GTM_US_AUTH
  } = t0;
  const isCA = NEXT_PUBLIC_LOCALE === "en-CA";
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isCA ? {
      gtmContainerId: NEXT_PUBLIC_GTM_CA_CONTAINER_ID,
      gtmPreview: NEXT_PUBLIC_GTM_CA_PREVIEW,
      gtmAuth: NEXT_PUBLIC_GTM_CA_AUTH
    } : {
      gtmContainerId: NEXT_PUBLIC_GTM_US_CONTAINER_ID,
      gtmPreview: NEXT_PUBLIC_GTM_US_PREVIEW,
      gtmAuth: NEXT_PUBLIC_GTM_US_AUTH
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    gtmAuth,
    gtmPreview,
    gtmContainerId
  } = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Script id="gtm-script" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: `
(function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),
    dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.onload = function() {
        console.log('GTM Loaded at', Date.now());
        w[l].push({event: 'loaded-gtm'})
    }
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x';
    f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmContainerId}');
`
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};